import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { pageView } from 'src/modules/googleAnalytics';
import { isProduction } from 'src/utils/config';
import {
  Breadcrumbs, Link, Typography, Container, Box
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import BigBang from 'src/components/Animations/BigBang';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';

import { makeStyles } from '@material-ui/styles';


const Page = ({
  title, loading, disableHeader = false, disableBreadcrumbs = false, children
}) => {
  const { t } = useTranslation('routes');
  const location = useLocation();
  const params = Object.values(useParams());


  const useStyles = makeStyles((theme) => ({
    active: {
      fontWeight: '500',
      color: theme.palette.type === 'light' ? theme.palette.background.dark : theme.palette.text.secondary
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    isProduction && pageView(`${location.pathname}${location.search}`);
  }, [location]);


  const getBreadCrumbs = () => {
    const pathnames = location.pathname.split('/').filter((p) => p && !params.includes(p));

    return (
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Link
          underline="hover"
          key={0}
          component={RouterLink}
          color="inherit"
          to="/profile/1/timeline"
        >
          <HomeOutlinedIcon />
        </Link>

        {pathnames.map((pathname, i) => {
          const last = i === pathnames.length - 1;

          if (last) {
            return <Typography className={classes.active} key={i}>{t(pathname)}</Typography>;
          }

          if (location.state?.redirect) {
            return (
              <Link
                underline="hover"
                key={i}
                component={RouterLink}
                color="inherit"
                to={location.state.redirect}
              >
                {t(pathname)}
              </Link>
            );
          }

   

          const to = `/${pathnames.slice(0, i + 1).join('/')}`;

          return (
            <Typography underline="hover" key={i} color="inherit" to={to}>
              {t(pathname)}
            </Typography>
          );
        })}
      </Breadcrumbs>
    );
  };
  // return null
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {loading ? (
        <BigBang />
      ) : (
        <Container maxWidth={false}>
          <Box mt={2} mb={4} height={!disableBreadcrumbs ? 21 : 'auto'}>
            {!disableBreadcrumbs && getBreadCrumbs()}
          </Box>
          {!disableHeader && (
            <Box mb={2}>
              <Typography gutterBottom variant="h4">
                {t(title)}
              </Typography>
            </Box>
          )}
          <Box mb={5}>{children}</Box>
        </Container>
      )}
    </>
  );
};

Page.propTypes = {
  title: PropTypes.string.isRequired,
  header: PropTypes.string,
  loading: PropTypes.bool,
  breadcrumbs: PropTypes.bool,
  children: PropTypes.node.isRequired
};

export default Page;
